import { render, staticRenderFns } from "./venueNeed.vue?vue&type=template&id=52d49e69&"
import script from "./venueNeed.vue?vue&type=script&lang=js&"
export * from "./venueNeed.vue?vue&type=script&lang=js&"
import style0 from "./venueNeed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports